module.exports = __webpack_public_path__ + "img/1.cdb75869.png";